module.exports = __webpack_public_path__ + "img/map_Z5.1.A.03.4cfc4dad.svg";